import GiayBaoNoDocumentEntry from '@/features/tien-gui/hach-toan/giay-bao-no/DocumentEntry';
import GiayBaoCoDocumentEntry from '@/features/tien-gui/hach-toan/giay-bao-co/DocumentEntry';
import PhieuThuDocumentEntry from '@/features/tien-mat/hach-toan/phieu-thu/DocumentEntry';
import PhieuChiDocumentEntry from '@/features/tien-mat/hach-toan/phieu-chi/DocumentEntry';
import type { CashBookDocumentEntryState } from '../utils/document-entry';

interface CashBookDocumentEntryProps {
  document: CashBookDocumentEntryState;
  onClose: () => void;
  onMutated?: () => void | Promise<void>;
}

export default function CashBookDocumentEntry({ document, onClose, onMutated }: CashBookDocumentEntryProps) {
  const entryProps = {
    document_uuid: document.documentUuid,
    document_type: document.documentType,
    formMode: 'view' as const,
    onClose,
    onMutated
  };

  switch (document.entryType) {
    case 'PHIEU_THU':
      return <PhieuThuDocumentEntry {...entryProps} />;
    case 'PHIEU_CHI':
      return <PhieuChiDocumentEntry {...entryProps} />;
    case 'GIAY_BAO_CO':
      return <GiayBaoCoDocumentEntry {...entryProps} />;
    case 'GIAY_BAO_NO':
      return <GiayBaoNoDocumentEntry {...entryProps} />;
    default:
      return null;
  }
}
